/** Perf beacon → api logs (grep "[perf]"). Opt-in per machine via
 *  localStorage neonpurge.perf="1" so it never spams normal players; used to
 *  watch real frame stats from several machines at once while tuning. */
let lastPerfAt = 0;
export function perfBeacon(gpu: string, area: string, line: string): void {
  let on = false;
  try { on = localStorage.getItem("neonpurge.perf") === "1"; } catch { /* private */ }
  if (!on) return;
  const now = Date.now();
  if (now - lastPerfAt < 4500) return; // ~ every 5 s
  lastPerfAt = now;
  try {
    void fetch("/api/clientlog", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ msg: `[perf] ${area} | ${gpu} | ${line}`, build: __BUILD_STAMP__, ua: gpu }),
    }).catch(() => { /* offline — fine */ });
  } catch { /* never throw */ }
}

/** Fire-and-forget error beacon → api logs (phones have no devtools; grep
 *  the api container for "[clientlog]" to read field errors). */
let sent = 0;

export function reportClientError(msg: string, stack?: string): void {
  if (sent++ >= 5) return; // an error loop must not flood the api
  try {
    void fetch("/api/clientlog", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({
        msg: msg.slice(0, 300),
        stack: stack?.slice(0, 600),
        build: __BUILD_STAMP__,
        ua: navigator.userAgent,
      }),
    }).catch(() => { /* offline — fine */ });
  } catch { /* the reporter must never throw */ }
}
